import { graphql, useMutation } from 'react-relay';
import type { useSubmitPollMutation as useSubmitPollMutationType } from './__generated__/useSubmitPollMutation.graphql';

const submitPollMutation = graphql`
  mutation useSubmitPollMutation($input: SubmitInput!) {
    submit(input: $input) {
      id
      responseStatistics {
        key
        ratio
        correct
        selected
      }
    }
  }
`;

export function useSubmitPollMutation() {
  return useMutation<useSubmitPollMutationType>(submitPollMutation);
}
